<div data-testid="zone-tile">
    <div class="zone__top border-zone" [class.cursor-pointer]="tile.menuId" (click)="setTemplate()">
        <floating-subtitle class="zone__name zone__name--valve font-21" [text]="tileName"/>
        <div class="zone__set-temperature bg-gradient bg-gradient--zone font-24">
            <p class="zone__set-temp font-bold" data-testid="set-temp">
                {{ tile.params.setTemp | format:7 }}
            </p>
            <div class="zone__actuator" [title]="labels.openingPercentage">
                <img class="zone__actuator-img"
                     ngSrc="/assets/img/zone_icons/actuators_open_white.svg"
                     width="40" height="40" alt=""/>
                <p class="zone__actuator-name font-15">
                    {{ tile.params.openingPercentage | format:8 }}
                </p>
            </div>
        </div>
    </div>

    <div class="zone__status" [class.cursor-pointer]="tile.menuId">
        <div class="gradient-zone zone__status-background" data-testid="animation"
             [class.zone__status--animated]="tile.params.workingStatus"
             (click)="setTemplate()"
        ></div>
    </div>

    <div class="zone__content" [class.cursor-pointer]="tile.menuId" (click)="setTemplate()">
        <div class="zone__content-icon">
            <icon [iconName]="'valve'"
                  data-testid="tile-icon-valve"
                  [iconSize]="isMobile ? 40 : 50"
                  [className]="'zone__icon zone__icon--white zone__icon--tile fill-icon-grey'">
            </icon>
            <icon [iconName]="'valve'"
                  data-testid="tile-icon-valve-mobile"
                  [iconSize]="isMobile ? 40 : 50"
                  [className]="'zone__icon zone__icon--dark fill-black fill-icon-grey'">
            </icon>
        </div>
        <div class="zone__current-temp" data-testid="tile-value">
            {{ tile.params.currentTemp | format:7 }}
        </div>
    </div>

    <div class="zone__footer bg-style">
        <div class="zone__icons">
            <div class="zone__footer-icon zone__footer-icon--relay-status">
                <div class="zone__img-wrapper border-light ml-12"
                     [title]="labels.openingPercentage">
                    <img ngSrc="/assets/img/zone_icons/actuators_open_white.svg"
                         class="zone__img-wrapper--actuators-open"
                         width="25" height="25" alt=""/>
                    <p class="font-15" data-testid="opening-percentage">
                        {{ tile.params.openingPercentage | format:8 }}
                    </p>
                </div>
            </div>
        </div>
        <div class="zone__icons">
            <div class="zone__settings bg-input bg-input--open bg-input--primary cursor-pointer"
                 (click)="toggleParameters()">
                <icon [iconName]="'settings'"
                      data-testid="settings-icon"
                      [iconSize]="40"
                      [className]="'fill-icon fill-icon--white'">
                </icon>
            </div>
        </div>
    </div>

    @if (showParameters) {
        <div (click)="toggleParameters()">
            <simple-valve-parameters [tile]="tile" />
        </div>
    }

    <div class="zone__relay-status-mobile fill-style">
        <img class="zone__relay-status-img"
             ngSrc="/assets/img/zone_icons/sun_v1-1.svg"
             data-testid="relay-status-mobile-icon"
             [class.zone__relay-status-mobile--animated]="tile.params.workingStatus"
             width="25" height="25" alt=""/>
    </div>
</div>
